import Vue from "vue";
import App from "./App";
import "./assets/css/common.scss";
import Vant from "vant";
import i18n from "@/i18n/i18n";
import router from "./router";
import store from "./store";
import "vant/lib/index.less";
import { createHttpServer } from "@/api/axios";
import { safeValue } from "@/utils/common";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Vue.prototype.$safeValue = safeValue;

// 在非开发环境使用sentry捕捉错误
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    Vue,
    dsn: "https://67f8c542e59b417f8ad3856e99560aa4@sentry.gtech.asia/24",
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
}

Vue.config.productionTip = false;
Vue.prototype.$http = createHttpServer("speedbiz");
Vue.prototype.$http_op = createHttpServer("speedbiz-operation");

Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js